import React, { useState } from 'react'
import httpClient from '../components/helpers/httpClient'
import './ForgotPasswordPage.css'
import { useNavigate, Link } from "react-router-dom"
import CircularProgress from '@mui/material/CircularProgress'
import { toast } from "react-toastify"
import logo_black from "../assets/logos/Logo-Vitruvi-transparant_Wit.png"

function ForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!email) {
      toast.error("Please enter your email address")
      return
    }

    setLoading(true)

    try {
      const data = { email }
      await httpClient.post(import.meta.env.VITE_API_URL + "/api/admin/reset-password", data)
      
      setSubmitted(true)
      toast.success("If an account with that email exists, a password reset link has been sent.")
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data.error || "Please enter a valid email address")
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }

    setLoading(false)
  }

  const handleEnter = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleSubmit(event)
    }
  }

  if (submitted) {
    return (
      <div className="body-forgotpassword">
        <img src={logo_black} alt="Vitruvi logo black" />
        <div className="forgotpassword-form">
          <h2>Check Your Email</h2>
          <p>If an account with that email exists, we've sent you a password reset link.</p>
          <p>The link will expire in 2 hours.</p>
          <div className="forgotpassword-links">
            <Link to="/">Back to Login</Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="body-forgotpassword">
      <img src={logo_black} alt="Vitruvi logo black" />
      <form className='forgotpassword-form' onSubmit={handleSubmit}>
        <h2>Forgot Password</h2>
        <p>Enter your email address and we'll send you a link to reset your password.</p>
        <input
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder='EMAIL'
          onKeyDown={handleEnter}
          type="email"
          disabled={loading}
        />

        <button type='submit' className='button-forgotpassword' disabled={loading}>
          <div className={`${loading ? "hide" : ""}`}>SEND RESET LINK</div>
          {loading && <CircularProgress color="inherit" size={"2.3rem"} />}
        </button>
        <div className='forgotpassword-links'>
          <Link to='/'>Back to Login</Link>
        </div>
      </form>
    </div>
  )
}

export default ForgotPasswordPage

